import { Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { GroupService } from '../../../services/group.service';
import {ModalConfirmComponent} from '../../../modal-confirm/modal-confirm.component';
import {OfficeComponent} from '../office/office.component';

@Component({
  selector: 'app-offices',
  templateUrl: './offices.component.html',
  styleUrls: ['./offices.component.scss']
})
export class OfficesComponent implements OnInit {
  userId: any;
  userToken: any;
  listOffices = [];
  listCompanies = [];
  temp = [];
  load = true;

  constructor(private toastr: ToastrService, public dialog: MatDialog, private gralService: GeneralService, private groupService: GroupService) {
    const b = JSON.parse(decodeURIComponent(localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352')));
    this.userId = b['id'];
    this.userToken = b['session_token'];
    gralService.changeTextHead('OFFICES');
    this.getOffices();
    this.getCompanies();
  }

  ngOnInit() {
  }



  getOffices(){
    this.groupService.getOffices(this.userId, this.userToken).then((data) => {
      this.listOffices = data['msg'];
      this.temp = data['msg'];
      this.load = false;
    }, (err) => {
      console.log(err);
      this.load = false;
      this.listOffices = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }

      if(err['status'] != 400){
        this.toastr.error(err['error'].msg, 'Error al cargar lista');
      }
    });
  }

  getCompanies(){
    this.groupService.getCompaniesActive(this.userId, this.userToken).then((data) => {
      this.listCompanies = data['msg'];
    }, (err) => {
      console.log(err);
      this.listCompanies = null;
      if(err['status'] != 400){
        this.toastr.error(err['error'].msg, 'Error al cargar lista de usuarios');
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {
      let ret = d.name.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.company.name.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.company.razon_social.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.country.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.state.toLowerCase().indexOf(val) !== -1 || !val;
      ret = ret+d.status.toLowerCase().indexOf(val) !== -1 || !val;
      return ret;
    });
    // update the rows
    this.listOffices = temp;
  }

  add(){
    const dialogRef = this.dialog.open(OfficeComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: { type: 'add', userId: this.userId, userToken: this.userToken, companies: this.listCompanies }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        if(this.listOffices){
          this.listOffices.push(result['data']);
        }else{
          this.getOffices();
        }
      }
    });
  }

  edit(id, idx){
    this.groupService.getOffice(id, this.userId, this.userToken).then((data) => {
      const dialogRef = this.dialog.open(OfficeComponent, {
        minWidth: '50%',
        position: {
          top: '6%'
        },
        data: { type: 'edit', id: id, info: data['msg'], userId: this.userId, userToken: this.userToken, companies: this.listCompanies }
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.toastr.success('Sucursal actualizada', 'Editar sucursal');
          this.listOffices[idx] = result['data'];
        }
      });
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Editar sucursal');
    });
  }


  changeStatus(id, status, idx){
    let dataa = {};
    if(status == 'inactive'){
      dataa = { type: 'delete', id: id, button: 'Desactivar', title: 'Desactivar sucursal', content: '¿Esta seguro de deactivar esta sucursal?', icon: 'warning' };
    }else{
      dataa = { type: 'active', id: id, button: 'Activar', title: 'Activar sucursal', content: '¿Esta seguro de activar esta sucursal?', icon: 'warning' };
    }


    const dialogRef = this.dialog.open(ModalConfirmComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: dataa
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        const params = {status: status};
        this.groupService.statusOffice(id, params, this.userId, this.userToken).then(data => {
          this.listOffices[idx].status = status;
          this.toastr.success('Se cambio el estatus de la sucursal', 'Cambiar estatus');
        }, (err) => {
          console.log(err);
          this.toastr.error('Error al cambiar estatus de la sucursal', 'Cambiar estatus');
          if(err.status == 401){
            // logout
          }
        });
      }
    });
  }

}
